import { render } from "./CombinedReporting.vue?vue&type=template&id=0ff047c0&scoped=true"
import script from "./CombinedReporting.vue?vue&type=script&lang=js"
export * from "./CombinedReporting.vue?vue&type=script&lang=js"

import "./CombinedReporting.vue?vue&type=style&index=0&id=0ff047c0&lang=postcss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff047c0"]])

export default __exports__